import { Network } from "../../.."
import store from "../../../../store"
import { Person } from "../profile"

class PatientAttributes extends Person {
	createdTs: number
	deletedTs: number
	firstName: string
	id: string
	lastName: string
	modifiedTs: number
	userId: string
}

class Patient extends PatientAttributes {
	static async getAll({ params }: { params?: { user: Network.API.Profile.User } }): Promise<Map<string, Patient>> {
		const { data: dependentData } = await Network.AxiosWrapperV2.get({
			url: "dependent"
		})
		const dependents = new Map()
		if (params?.user) {
			dependents.set(params.user.patientId, new Patient({ id: params.user.patientId, ...params.user }))
		}
		dependentData.forEach((d) => {
			dependents.set(d.id, new Patient(d))
		})
		return dependents
	}

	static async getOne({ params }: { params: { id: string } }): Promise<Patient> {
		const { data: dependentData } = await Network.AxiosWrapperV2.get({
			url: `dependent/${params.id}`
		})
		return new Patient(dependentData)
	}

	async update(): Promise<Patient> {
		try {
			const { data: dependentData } = await Network.AxiosWrapperV2.post({
				url: `dependent/${this.id}`
			})
			store.setNotification("notification", true, {
				msg: "Successfully updated patient."
			})
			return new Patient(dependentData)
		} catch (err) {
			console.error(err)
		}
	}

	async delete(): Promise<boolean> {
		try {
			const { data: dependentData } = await Network.AxiosWrapperV2.delete({
				url: `dependent/${this.id}`
			})
			store.setNotification("notification", true, {
				msg: "Successfully deleted dependent."
			})
			return true
		} catch (err) {
			console.error(err)
		}
		return false
	}
}

export default Patient
